import { useLayoutEffect, useState } from "react";
import WorldMpProvider from "@/core/data-provider/data-mp/world/world-mp-provider";
import dateTimeFromUnix from "@/core/helpers/dateTimeFromUnix";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";

export default function useGetServerDate() {
  const [serverTime, setServerTime] = useState(null);

  useLayoutEffect(() => {
    const fetchTime = async () => {
      const timeDiffStr = sessionStorage.getItem("timeDiff");
      const storedTimeDiff = timeDiffStr ? Number(timeDiffStr) : null;
      const storedTimeZone = sessionStorage.getItem("timeZone");

      if (storedTimeDiff !== null && storedTimeZone !== null) {
        const currTime = Math.floor(Date.now() / 1000) + storedTimeDiff;
        setServerTime(dateTimeFromUnix(currTime, storedTimeZone));
      } else {
        try {
          const response = await WorldMpProvider.getWorldTime();

          if (response instanceof RpcMpProviderSuccessResponse) {
            const serverData = response.data.server;
            const newTimeDiff = serverData.timestamp - Math.floor(Date.now() / 1000);
            const newTimeZone = serverData.timezone;

            sessionStorage.setItem("timeDiff", newTimeDiff.toString());
            sessionStorage.setItem("timeZone", newTimeZone);

            setServerTime(dateTimeFromUnix(serverData.timestamp, newTimeZone));
          } else {
            console.error("Failed to fetch useGetServerDateAndTime");
          }
        } catch (e) {
          console.error("Failed to fetch useGetServerDateAndTime:", e);
        }
      }
    };

    fetchTime();
  }, []);

  return serverTime;
}
